module.exports = __webpack_public_path__ + "img/6af83f5c8d5b4e1988f263558b3440f2.af8443ca.jpg";